<template>
  <div id="hospitalPicker" v-show="showAddressPicker">
    <div class="hospital_box cl" v-if="!showSearch">
      <p class="h_address">
        {{ address[0] + '-' + address[1] + '-' + address[2] }}
      </p>
      <div class="h_top cl">
        <p>等级</p>
        <p style="position: relative;">
          <span>医院名称</span>
          <img
            @click="toSearchPage"
            class="searchImg"
            src="//cdn.yxvzb.com/html/perfect/u2.png"
            alt=""
          />
        </p>
      </div>
      <ul class="h_left">
        <li
          v-for="(item, index) in level"
          :class="[l_index == index ? 'c_blue' : '']"
          @click="changeLevel(item, index)"
        >
          {{ item }}
        </li>
      </ul>
      <div class="h_right">
        <ul>
          <li v-for="item in hosList" @click="hidePicker(item)">
            {{ item.fullName }}
          </li>
        </ul>
        <p class="cantFind" @click="addHospital">未找到？添加我的医院／机构</p>
      </div>
    </div>
    <div class="hospital_box cl search_div" v-else>
      <div class="search_box">
        <input type="text" v-model.trim="keyWord" @keyup.13="getKeyHosList" />
        <img src="//cdn.yxvzb.com/img/PCimg_06.jpg" @click="getKeyHosList" />
      </div>
      <ul class="search_list">
        <li @click="searchLiClick(item)" v-for="(item, index) in searchList">
          {{ item.fullName }}
        </li>
      </ul>
      <p class="cantFind search_find" @click="addHospital">
        未找到？添加我的医院／机构
      </p>
    </div>
    <div v-transfer-dom>
      <confirm
        v-model="addShow"
        show-input
        ref="confirm"
        @on-confirm="onConfirm"
        @on-show="onShow"
        title="添加医院"
      ></confirm>
    </div>
  </div>
</template>

<script>
//	import { MessageBox } from 'mint-ui';
// TODO: vux
import { Confirm, TransferDomDirective as TransferDom } from 'vux';
import { hospitalList } from '@/api/ajax';
export default {
  name: 'hospitalPicker',
  props: ['address', 'showAddressPicker', 'districtId', 'cityId'],
  data() {
    return {
      level: [
        '三甲',
        '二甲',
        '二乙',
        '一甲',
        '一乙',
        '三级',
        '二级',
        '一级',
        '其他'
      ],
      l_index: 0, //levelIndex
      hosList: [], //对应level的医院
      hospitalArr: [], //医院LIST
      showSearch: false,
      keyWord: '',
      searchList: [], //所搜结果
      addShow: false //添加医院POP
    };
  },
  directives: {
    TransferDom
  },
  components: {
    Confirm
  },
  methods: {
    /*
     * 查找医院
     * */
    getKeyHosList() {
      this.$http
        .post(this.$config.urlPath + '/hospital/list', {
          keyWord: this.keyWord,
          city: this.address[1],
          county: this.address[2]
        })
        .then(res => {
          this.searchList = res.data.data;
        });
    },

    init() {
      this.showSearch = false;
    },
    /*
     * 点击后传参 @item String
     * */
    searchLiClick(item) {
      this.$emit('save-hospital', item);
      this.init();
    },
    /*
     * 显示搜索层
     * */
    toSearchPage() {
      this.showSearch = true;
    },
    /*
     * 根据level 过滤数据
     * */
    hospitalInfo(eleindex) {
      let arr = [];
      this.hospitalArr.forEach((item, index) => {
        if (
          item.level == this.level[eleindex] ||
          (eleindex == 8 && !item.level)
        ) {
          arr.push(item);
        }
      });
      this.hosList = arr;
    },
    /*
     * 点击医院列表传参 @item obj
     * */
    hidePicker(item) {
      this.$emit('save-hospital', item);
    },
    /*
     * 切换等级
     * */
    changeLevel(item, index) {
      this.l_index = index;
      this.hospitalInfo(index);
    },
    /*
     * 显示添加医院层
     * */
    addHospital(value) {
      this.addShow = true;
    },
    /*
     * 添加层 出现事件
     * */
    onShow() {
      this.$refs.confirm.setInputValue('');
    },
    /*
     * 添加层 点击确定后传参 @value String
     * */
    onConfirm(value) {
      this.$emit('save-hospital', value);
      this.init();
    },
    /*
     * 获取医院列表
     * */
    getHospital(addressObj, resolve) {
      hospitalList({
        cityId: addressObj[1],
        districtId: addressObj[2]
      }).then(res => {
        //					res.data.forEach(item => {
        //						this.hospitalArr.push(item.full_name)
        //					})
        this.hospitalArr = res.data.data;
        resolve('success');
      });
    }
  },

  watch: {
    /*
     * 监听地址变化change医院数据
     * */
    address(n, o) {
      let promiseHos = () => {
        return new Promise((resolve, reject) => {
          this.getHospital(n, resolve);
        });
      };
      promiseHos().then(res => {
        this.hospitalInfo(0);
      });
    }
  }
};
</script>

<style lang="less" scoped>
/*搜索*/
.search_find {
  width: 70%;
  background: #027cfa;
  font-size: 0.4rem;
  color: #fff;
  text-align: center;
  padding: 0.3rem;
  border-radius: 0.15rem;
  margin: 0 auto;
}
.search_div {
  padding: 0.4rem;
}

.search_list {
  padding: 0.4rem 0.8rem;
  /*background: red;*/
  height: 12rem;
  overflow: auto;
  li {
    font-size: 0.4rem;
    padding: 0.3rem 0;
  }
}

.search_box {
  display: flex;
  justify-content: center;
  margin-top: 0.4rem;
  input {
    font-size: 0.4rem;
    border: 1px solid #dedede;
    border-radius: 0.0666rem;
    padding: 0.0533rem 0.0666rem;
    width: 70%;
  }
}

.searchImg {
  position: absolute;
  width: 0.45rem;
  right: 1rem;
  top: 0.35rem;
}
/*搜索END*/

.hospital_box {
  position: absolute;
  z-index: 5;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #fff;
  .h_address {
    background: #027cfa;
    color: #fff;
    font-size: 0.4533rem;
    padding-left: 0.7333rem;
  }
  .h_top {
    background: #ffffff;
    box-shadow: 0 1px 1px 0 #d8d8d8;
    height: 1.1466rem;
    p {
      float: left;
      font-size: 0.4rem;
      line-height: 1.1466rem;
    }
    p:nth-of-type(1) {
      width: 16%;
      text-align: center;
    }
    p:nth-of-type(2) {
      width: 84%;
      text-align: center;
    }
  }
  .h_left {
    width: 16%;
    float: left;
    height: 100%;
    background: #fff;
    padding-top: 0.2933rem;
    li {
      text-align: center;
      font-size: 0.4rem;
      margin-bottom: 0.5866rem;
    }
  }
  .h_right {
    width: 84%;
    float: left;
    height: 100%;
    background: #f2f4f7;
    padding-top: 0.36rem;
    ul {
      height: 70%;
      overflow: auto;
      width: 100%;
      li {
        padding-left: 0.2666rem;
        font-size: 0.32rem;
        margin-bottom: 0.7066rem;
      }
    }
    .cantFind {
      font-size: 0.4rem;
      color: #027cfa;
      margin-top: 1.7333rem;
      padding-left: 0.2666rem;
    }
  }
}

.c_blue {
  color: #027cfa;
}
</style>
